import styled from 'styled-components'

import HideWhenBlockedUnstyled from 'Containers/UIBlock/HideWhenBlocked/unstyled'

export const HideWhenBlocked = styled(HideWhenBlockedUnstyled)`
  visibility: hidden;
`
